import { SiteContainer, SiteWhatsAppThread } from '../SiteUi';

const CHIPS = [
  { label: 'Lembrete de retorno', preview: 'ABC-1234 · 90 dias' },
  { label: 'Cobrança', preview: 'OS-1038 · R$ 420,00' },
  { label: 'NPS pós-serviço', preview: 'De 0 a 10?' },
];

export function SiteMechanismProof() {
  return (
    <section id="prova" className="scroll-mt-24 py-20 sm:py-28">
      <SiteContainer className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
        <div>
          <h2 className="max-w-[16ch] font-display text-[clamp(2rem,4vw,3.4rem)] font-semibold leading-[1.05] tracking-tight text-[#16181d]">
            Enquanto sua equipe trabalha, o AgilizaOS cuida de quem precisa voltar.
          </h2>
          <div className="mt-8 space-y-2">
            {CHIPS.map((chip) => (
              <div key={chip.label} className="flex items-center justify-between rounded-md border border-[#d9d4cc] bg-white px-3 py-3">
                <span className="text-sm text-[#16181d]">{chip.label}</span>
                <span className="font-os text-[11px] text-[#5c5852]">{chip.preview}</span>
              </div>
            ))}
          </div>
        </div>
        <SiteWhatsAppThread />
      </SiteContainer>
    </section>
  );
}
